<script setup>
import { ref, onMounted, computed } from 'vue'
import { useRouter } from 'vue-router'
import { storeToRefs } from 'pinia'
import learningApiUser from '@src/services/api/learning/user'
import { useLearningUserStore } from '@stores/user'
import Modal from '@components/modal/Modal.vue'

const { accountInfo } = storeToRefs(useLearningUserStore())
const router = useRouter()

const errorMessage = ref('')

const showCompleteModal = ref(false)
const accountFormItems = computed(() => {
  return [
    {
      label: '氏名/フリガナ',
      value: accountInfo.value.lastName + ' ' + accountInfo.value.firstName + ' / ' + accountInfo.value.lastNameKatakana + ' ' + accountInfo.value.firstNameKatakana
    },
    // {
    //   label: 'ニックネーム',
    //   value: accountInfo.value.nickname
    // },
    {
      label: '生年月日',
      value: accountInfo.value.year + '年' + accountInfo.value.month + '月' + accountInfo.value.date + '日'
    },
    {
      label: '性別',
      value: accountInfo.value.gender
    },
    {
      label: '自宅都道府県',
      value: accountInfo.value.pref
    },
    {
      label: '営業所会社名',
      value: accountInfo.value.office
    },
    {
      label: '営業所屋号',
      value: accountInfo.value.officeSection
    },
    {
      label: '会社住所',
      value: '〒' + accountInfo.value.officeZipcode + ' ' + accountInfo.value.officePref + ' ' + accountInfo.value.officeCity + ' ' + accountInfo.value.officeStreet + ' ' + accountInfo.value.officeBuilding
    },
    {
      label: '会社電話番号',
      value: accountInfo.value.officeTel
    },
    {
      label: '会社FAX番号',
      value: accountInfo.value.officeFax
    },
    {
      label: '販売責任者',
      value: accountInfo.value.officeManagerFlag ? 'はい' : 'いいえ'
    }
  ]
})

const sendAccountForm = () => {
  console.log('accountInfo', accountInfo.value)
  const body = {
    email: accountInfo.value.email,
    identifier: accountInfo.value.identifier,
    // name: accountInfo.value.nickname,
    password: accountInfo.value.password,
    displays: {
      name: [
        accountInfo.value.lastName,
        accountInfo.value.firstName
      ],
      spell: [
        accountInfo.value.lastNameKatakana,
        accountInfo.value.firstNameKatakana
      ],
      birthday: accountInfo.value.year + '-' + ('00' + Number(accountInfo.value.month)).slice(-2) + '-' + ('00' + Number(accountInfo.value.date)).slice(-2),
      gender: accountInfo.value.gender,
      address: {
        pref: accountInfo.value.pref
      },
      office: {
        name: accountInfo.value.office,
        section: accountInfo.value.officeSection ? accountInfo.value.officeSection : null,
        address: {
          zipcode: accountInfo.value.officeZipcode,
          pref: accountInfo.value.officePref,
          city: accountInfo.value.officeCity,
          street: accountInfo.value.officeStreet,
          building: accountInfo.value.officeBuilding ? accountInfo.value.officeBuilding : null
        },
        telephone: accountInfo.value.officeTel,
        facsimile: accountInfo.value.officeFax ? accountInfo.value.officeFax : null,
        manager: accountInfo.value.officeManagerFlag ? accountInfo.value.officeManagerFlag : false
      }
    }
  }
  console.log('body', body)
  learningApiUser.putUser(body).then((res) => {
    console.log('putUser res', res)
    // console.log('userInfo', userInfo)
    showCompleteModal.value = true
  }).catch((err) => {
    console.error('putUser err', err)
    errorMessage.value = 'エラーが発生しました。'
  })
}

const toTop = () => {
  showCompleteModal.value = false
  router.push({
    name: 'Dashboard'
  })
}

onMounted (() => {
  window.scrollTo(0, 0)
})
</script>

<template>
  <section>
    <div class="container">
      <h2>登録情報の確認・変更（確認）</h2>
      <p>
        入力した内容を確認し、確定ボタンを押してください。<br><br>
      </p>
      <div
        v-for="(item, index) in accountFormItems"
        :key="index"
        class="p-confirm-item"
      >
        <p class="p-confirm-item__label">
          {{ item.label }}
        </p>
        <p class="p-confirm-item__value">
          {{ item.value }}
        </p>
      </div>

      <!-- APIエラー表示 -->
      <div
        v-if="errorMessage"
        class="p-form-error">
        {{ errorMessage }}
      </div>

      <div>
        <button
          type="submit"
          class="c-button c-button--medium c-button--yellow"
          @click="sendAccountForm"
        >
          確定
        </button>
        <RouterLink
          :to="{name:'Account'}"
          class="c-button c-button--medium c-button--border"
        >
          戻る
        </RouterLink>
      </div>
    </div>

    <Modal :show="showCompleteModal">
      <template #body>
        <div class="l-modal__body">
          <h2 class="l-modal__ttl">
            更新しました。
          </h2>
          <div class="l-modal__buttons">
            <button
              class="c-modalBtn c-modalBtn--single c-modalBtn--gray"
              type="button"
              @click="toTop"
            >
              トップページ
            </button>
          </div>
        </div>
      </template>
    </Modal>
  </section>
</template>

<style scoped lang="scss">
.container {
  h2 {
    padding: 30px 0 15px;
    font-size: 26px;
    text-align: left;
    font-weight: bold;
  }
}
.btnContainer {
  margin-top: 20px;
}
</style>
